<script lang="ts" setup></script>
<template>
  <div class="gemx-header bg-dark-500 text-light-low flex h-[56px] w-full items-center justify-between p-8 fixed top-0">
    <div class="relative z-10 flex gap-8">
      <div class=""><slot name="logo"> </slot></div>
      <div class="">
        <slot name="library"> </slot>
      </div>

      <div class="">
        <slot name="devices"> </slot>
      </div>
      <div class="">
        <slot name="history"> </slot>
      </div>
    </div>
    <slot name="layer-tree"></slot>
    <!-- <div class="xl:pl-sidebar lss:pl-0 lss:pr-44 absolute inset-x-0 flex items-center justify-center gap-8"> -->
    <div class="mx-auto">
      <slot class="" name="page"> </slot>
    </div>
    <!-- </div> -->
    <div class="relative z-10 flex h-40 items-center gap-8">
      <slot name="save-and-preview"> </slot>
      <div class=""><slot class="" name="assign"> </slot></div>
      <div class="">
        <slot name="save"> </slot>
      </div>
      <div class="">
        <slot name="publish"> </slot>
      </div>
      <!-- <div>
        <slot name="moreSettings"> </slot>
      </div> -->
      <slot name="gettingStarted"> </slot>
    </div>
  </div>
</template>
